import Route from '@ember/routing/route';
import throwUnlessTaskDidCancel from 'garaje/utils/throw-unless-task-did-cancel';
import { hash } from 'rsvp';
import { service } from '@ember/service';
import { set } from '@ember/object';

export default class DeliveriesRoute extends Route {
  @service locations;
  @service state;
  @service store;
  @service router;

  titleToken = 'Deliveries';

  beforeModel() {
    const { workplaceSubscription } = this.state;

    if (!this.state.features?.canAccessDeliveriesApplication && workplaceSubscription?.cancelled) {
      this.router.transitionTo('workplace.trial-ended');
    }
  }

  model() {
    const { currentCompany: company, deliveriesSubscription, vrSubscription } = this.state;
    let deliveryAreas = [];
    let deliveryLimit;
    if (this.state.features?.canAccessDeliveriesApplication) {
      deliveryAreas = this.store.findAll('delivery-area');
      deliveryLimit = this.store.queryRecord('delivery-limit', {});
    }
    return hash({ company, deliveryAreas, deliveriesSubscription, deliveryLimit, vrSubscription });
  }

  async afterModel() {
    await this.locations.loadAllTask.perform().catch(throwUnlessTaskDidCancel);
  }

  setupController(_controller, _model) {
    super.setupController(...arguments);
    set(this, 'state.showDeliveriesOnboarding', false);
  }
}
